// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NTGa8","newExpiryDate":"styles_newExpiryDate__3cJGa","footer":"styles_footer__2c2Om"};